import React from 'react';
import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import handleFetchErrors from '@adsk/bim360-matrix-react-helpers/es/handleFetchErrors';
import { MEETINGS_ENV_CONFIG_KEYS } from './consts';
import getEnvConfig from './helpers/getEnvConfig';
import MeetingItemEntityBlock from './MeetingItemEntityBlock';
import MeetingItemLinkedEntitiesCellBlock from './MeetingItemLinkedEntitiesCellBlock';
import MeetingItemLinkedEntitiesCellItem from './MeetingItemLinkedEntitiesCellItem';

export default {
  entityType: ENTITY_TYPES.MEETING_ITEM_SINGLE,
  metadata: {},
  createPlugin: ({ env, region, projectId, getToken }) => {
    const baseUrl = getEnvConfig(env, region, MEETINGS_ENV_CONFIG_KEYS.MEETINGS_BE);
    // in the relationship service the link is made on the item's 'crossSeriesId' instead of its actual 'id'
    // the linker's handling requires the passed entity's id to match the value/id linked in the relationship service
    const parseEntity = entity => ({
      ...entity,
      id: entity.id,
      itemId: entity.id,
      entityType: ENTITY_TYPES.MEETING_ITEM_SINGLE
    });

    const EntityBlock = props => {
      return <MeetingItemEntityBlock {...props} env={env} region={region} projectId={projectId} />;
    };

    const LinkedEntitiesCellBlock = props => (
      <MeetingItemLinkedEntitiesCellBlock
        {...props}
        env={env}
        region={region}
        projectId={projectId}
      />
    );

    return {
      getEntitiesByIds: entityIds =>
        getToken()
          .then(token => {
            const idChunks = chunk(entityIds, 20);
            return Promise.all(
              idChunks.map(idsBatch =>
                fetch(
                  `${baseUrl}/v1/projects/${projectId}/items:batch?ids=${idsBatch.join(
                    ','
                  )}&reduceToLastInSeries=true`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`
                    }
                  }
                )
              )
            );
          })
          .then(responses => responses.map(handleFetchErrors))
          .then(responses => Promise.all(responses.map(res => res.json())))
          .then(responses => flatten(responses))
          .then(response => ({ data: response.map(parseEntity) })),
      EntityBlock,
      LinkedEntitiesCellBlock,
      LinkedEntitiesCellItem: MeetingItemLinkedEntitiesCellItem
    };
  }
};
